import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Abdominal } from '../models/abdominal';

@Injectable({
  providedIn: 'root',
})
export class AbdominalService {
  
  private api = '/api/Abdominal';

  constructor(private http: HttpClient) { }

  // =====================
  // READ (User/Admin)
  // =====================
  getAll(): Observable<Abdominal[]> {
    return this.http.get<Abdominal[]>(this.api);
  }

  getById(id: number): Observable<Abdominal> {
    return this.http.get<Abdominal>(`${this.api}/${id}`);
  }

  // =====================
  // WRITE (Admin only no backend)
  // =====================
  create(model: Abdominal): Observable<Abdominal> {
    return this.http.post<Abdominal>(this.api, model);
  }

  update(model: Abdominal): Observable<void> {
    return this.http.put<void>(`${this.api}/${model.id}`, model);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }
}
